import React, { useState } from "react";

// CSS

import "./css/CorporateSocialResponsibility.scss";

// Components

import TitleBox from "../components/TitleBox";
import Footer from "../components/Footer";

// Images

import image_1_1 from "../assets/images/csr/1-1.png";
import image_1_2 from "../assets/images/csr/1-2.png";
import image_1_3 from "../assets/images/csr/1-3.png";
import image_1_4 from "../assets/images/csr/1-4.png";
import image_1_5 from "../assets/images/csr/1-5.png";
import image_1_6 from "../assets/images/csr/1-6.png";

import image_2_1 from "../assets/images/csr/2-1.png";
import image_2_2 from "../assets/images/csr/2-2.png";
import image_2_3 from "../assets/images/csr/2-3.png";
import image_2_4 from "../assets/images/csr/2-4.png";

import image_3_1 from "../assets/images/csr/3-1.png";

const CorporateSocialResponsibility = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  return (
    <div
      className='csr-container'
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"Corporate Social Responsibility"} />
      <div className='table-container'>
        <div className='table-title'>Cottolengo Filipino Inc.</div>
        <div className='table-desc'>Rodriguez, Rizal</div>
        <div className='table-main'>
          <div className='row 1'>
            <div className='image-container lg'>
              <img src={image_1_1} />
            </div>
            <div className='image-container '>
              <img src={image_1_2} />
            </div>
            <div className='image-container'>
              <img src={image_1_3} />
            </div>
          </div>
          <div className='row 2'>
            <div className='image-container'>
              <img src={image_1_4} />
            </div>
            <div className='image-container'>
              <img src={image_1_5} />
            </div>
            <div className='image-container lg'>
              <img src={image_1_6} />
            </div>
          </div>
        </div>
        <div className='table-title'>Philippine Children's Medical Center</div>
        <div className='table-desc'>Quezon City</div>
        <div className='table-main tbl-2'>
          <div className='row 1'>
            <div className='image-container lg'>
              <img src={image_2_1} />
            </div>
            <div className='image-container '>
              <img src={image_2_2} />
            </div>
          </div>
          <div className='row 2'>
            <div className='image-container'>
              <img src={image_2_3} />
            </div>
            <div className='image-container lg'>
              <img src={image_2_4} />
            </div>
          </div>
        </div>
        <div className='table-title'>Manila Adventist Hospital</div>
        <div className='table-desc'>Pasay City</div>
        <div className='table-main tbl-3'>
          <div className='image-container'>
            <img src={image_3_1} />
          </div>
        </div>
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default CorporateSocialResponsibility;
